import React from 'react'
import {
    FormCell, CellBody, CellFooter, Switch, Button,
    CellHeader, Label, Input, Toptips, Toast, Dialog, Form, Radio,
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { WKGreenTitle, WKTextarea } from '../../components/wk'
import { Page } from '../../components'
import { WKVisible } from '../../components/wk'
import {TimeStream, storage, isLZWKAPP} from '../../utils'
import { addSuccess } from '../../utils/connectApp'
import '../../css/page/LectureCreatePage.css'


class LectureCreateFormPage extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            type: 'live',
            categories: [],
            parentCategory: '',
            category: '',
            title: '',
            startTime: '',
            // password, free, unfree
            selectedRadio: 'free',
            money: '',
            isResell: false,
            resellPercent: '',
            password: '',
            isPending: false,
            lectureId: '',
            isChannelNeedMoney: false,
            isShowParentCategorySelectDialog: false,
            isShowCategorySelectDialog: false,
            mode: 'picture',
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
            showExample: false,
            showExamplePic: '',
            isFirst: false,
        }
    }
    componentDidMount () {
        document.title = '创建课程'
        window.scrollTo(0,0)
        this.setState({
            parentCategory: storage.getItem('lecture_create_parent_category') || '',
            category: storage.getItem('lecture_create_category') || '',
        })
        // axios.get('/api/board/categories')
        //     .then(res => {
        //         this.setState({ categories: res.data.data.categories })
        //     })
        // 如果在专栏内创建课程，判断是否是付费专栏
        if (this.props.location.query.channel_id) {
            axios.get(`/api/channel/${this.props.location.query.channel_id}/short_info`)
                .then(res => {
                    this.setState({ 
                        isChannelNeedMoney: res.data.data.channel.need_money,
                        selectedRadio: res.data.data.channel.need_money ? 'payChannel' : 'free',
                    })
                })
        }
        axios.get(`/api/liveroom/${this.props.params.liveroom_id}/is_first_create`)
        .then(res => {
            if(res.data.data.is_first) {
                this.setState({title:`${res.data.data.liveroom_name}直播间的第一节课`})
            }
        })
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    bindValue (e, field) {
        const value = e.target.value
        if (field === 'parentCategory') {
            this.setState({ category: '' })
            storage.setItem('lecture_create_category', '')
            storage.setItem('lecture_create_parent_category', value)
        }
        if (field === 'category') {
            storage.setItem('lecture_create_category', value)
        }
        this.setState({ [field]: value })
    }
    verify () {
        // if (this.state.startTime < Date.now() / 1000) {
        //     return { status: false, msg: '开课时间不能早于当前时间' }
        // }
        const reg = /^[0-9]\d*|0$/;

        if (!this.state.type) return { status: false, msg: '请选择类型' }
        // if (this.state.category === '') return { status: false, msg: '请选择分类' }
        if (this.state.title.trim().length < 1 || this.state.title.trim().length > 100) return { 
            status: false, msg: '标题长度请控制在1-100个字符之间' 
        }
        if (!this.state.startTime) return { status: false, msg: '请填写开课时间' }
        if (this.state.selectedRadio === 'unfree') {
            const { money, resellPercent } = this.state
            if (!/^(-)?(([1-9]{1}\d*)|([0]{1}))(\.(\d){1,2})?$/.test(money) || money < 0) {
                return {
                    status: false,
                    msg: '请输入正确的价格',
                }
            }
            if (this.state.isResell) {
                if (!/^\d+$/.test(resellPercent) || (resellPercent < 0 || resellPercent > 100)) {
                    return {
                        status: false,
                        msg: '比例为0到100的整数',
                    }
                }
                if (money * resellPercent / 100 < 0.01) {
                    return {
                        status: false,
                        msg: '价格*分成比例必须大于或等于0.01',
                    }
                }
            }
        }
        if (this.state.selectedRadio === 'password') {
            // if (this.state.password.trim() === '') return { status: false, msg: '请填写密码' }
            if(!this.state.password.match(reg) || this.state.password.indexOf('.') > -1) return { status: false, msg: '请输入0-9的纯数字作为密码' }  
        }
        return { status: true }
    }
    onSubmit () {
        const verifyRes = this.verify()
        if (!verifyRes.status) {
            return this.showTip(verifyRes.msg)
        }
        let payData = {}
        // 专栏里添加课程
        let channelData = {} 
        if (this.state.selectedRadio === 'free') {
            payData = {
                need_money: false,
            }
        }
        if (this.state.selectedRadio === 'unfree') {
            if (this.state.isResell) {
                payData = {
                    need_money: true,
                    money: (this.state.money * 100).toFixed(),
                    resell_enabled: this.state.isResell,
                    resell_percent: this.state.resellPercent,
                }
            } else {
                payData = {
                    need_money: true,
                    money: (this.state.money * 100).toFixed(),
                }
            }
        }
        if (this.state.selectedRadio === 'password') {
            payData = {
                need_password: true,
                password: this.state.password
            }
        }
        if (this.state.selectedRadio === 'payChannel') {
            payData = {
                need_pay_channel: true,
            }
        }
        if (this.props.location.query.channel_id) {
            channelData = {
                channel: this.props.location.query.channel_id
            }
        }
        const submitData = {
            ...payData,
            ...channelData,
            name: this.state.title,
            category: this.state.category,
            start_time: this.state.startTime,
            image_mode: this.state.mode,
        }
        // /lecture/4844440?fr=create_lecture
        this.setState({ isPending: true })
        axios.post(`/api/liveroom/${this.props.params.liveroom_id}/add_lecture`, qs.stringify(submitData))
            .then(res => {
                this.setState({ isPending: false })
                if (res.data.code !== 0) {
                    return this.showTip(res.data.msg)
                }
                this.showAlert('创建成功')
                this.setState({ lectureId: res.data.data.lecture_id })
            })
    }
    onChangeStartTime (e) {
        const value = e.target.value.replace(/-/g,"/").replace(/T/g," ")
        const timestamp = Date.parse(value) / 1000
        this.setState({ startTime: timestamp })
    }
    onChangeRadio (e, value) {
        this.setState({ selectedRadio: value })
    }
    onClickSuccessOk () {
        if (isLZWKAPP()) {
            this.setState({ alertDialog: { isShow: false } })
            addSuccess('lecture', this.state.lectureId)
        } else {
            location.replace(`/lecture/${this.state.lectureId}?fr=create_lecture`)
        }
    }
    onFocusTime () {
        if (this.state.startTime) {
            return
        }
        setTimeout(() => {
            this.setState({ startTime: ~~(Date.now() / 1000 ) })
        }, 1000)
    }
    getIsShowBulk () {
        if (this.props.location.query.channel_id) {
            
        }
    }
    onClickParentCategorySelect () {
        // if (isLZWKAPP() && window.systemType === 'android') {
        //     this.setState({ isShowParentCategorySelectDialog: true })
        // }
    }
    onClickCategorySelect () {
        // if (isLZWKAPP() && window.systemType === 'android') {
        //     this.setState({ isShowCategorySelectDialog: true })
        // }
    }
    onChangeParentCategory (id) {
        this.setState({ parentCategory: id, isShowParentCategorySelectDialog: false, category: '' })
        storage.setItem('lecture_create_category', '')
        storage.setItem('lecture_create_parent_category', id)
    }
    onChangeCategory (id) {
        storage.setItem('lecture_create_category', id)
        this.setState({ category: id, isShowCategorySelectDialog: false })
    }
    onChangeModeRadio (e, value) {
        this.setState({ mode: value })
    }
    showExample (e){
        let index = e.target.dataset.id;
        if(index === "0"){
            this.onChangeModeRadio(e, 'picture')
            this.setState({showExamplePic:"https://static-1253442168.image.myqcloud.com/picture/6163344_a57b5b9c646f0ea3efb9f82f78e66556.jpg"})
        }else if(index === "1"){
            this.onChangeModeRadio(e, 'ppt')
            this.setState({showExamplePic:"https://static-1253442168.image.myqcloud.com/picture/6163344_6e185561e0e63c9ab293f22e17014990.jpg"})
        }else {
            this.onChangeModeRadio(e, 'video')
            this.setState({showExamplePic:"https://static-1253442168.image.myqcloud.com/picture/6163344_695d713822c27c236801ec41ec5169f2.jpg"})
        }
        this.setState({showExample: true})
    }
    render() {
        const {categories, parentCategory, category} = this.state
        let subCategories
        if (categories.length === 0 || parentCategory === '') {
            subCategories = []
        } else {
            subCategories = categories.find(item => item.id == parentCategory).sub_category
        }
        return (
            <Page>
                <div className="wk-inner-page lecture-create-form-page">
                    <div className="page__hd">
                        <h1 className="page__title">填写基本信息</h1>
                    </div>

                    <WKGreenTitle title='课件' />
                    <Form radio>
                        <FormCell radio>
                            <CellBody>无</CellBody>
                            <CellFooter>
                                <Radio 
                                    name="mode" 
                                    checked={this.state.mode === 'picture'} 
                                    onChange={e => this.onChangeModeRadio(e, 'picture')} 
                                />
                            </CellFooter>
                        </FormCell>
                        <span className="example-div" data-id="0" onClick={this.showExample.bind(this)} style={{top: '14px'}}>示例</span> 
                        <FormCell radio>
                            <CellBody>PPT</CellBody>
                            <CellFooter>
                                <Radio 
                                    name="mode" 
                                    checked={this.state.mode === 'ppt'} 
                                    onChange={e => this.onChangeModeRadio(e, 'ppt')} 
                                />
                            </CellFooter>
                        </FormCell>
                        <span className="example-div" data-id="1" onClick={this.showExample.bind(this)} style={{top: '59px'}}>示例</span>
                        <FormCell radio>
                            <CellBody>视频</CellBody>
                            <CellFooter>
                                <Radio 
                                    name="mode" 
                                    checked={this.state.mode === 'video'} 
                                    onChange={e => this.onChangeModeRadio(e, 'video')} 
                                />
                            </CellFooter>
                        </FormCell>
                        {/* <div>

                        </div> */}
                        <span className="example-div" data-id="2" onClick={this.showExample.bind(this)} style={{top: '104px'}}>示例</span>
                    </Form>
                    <WKGreenTitle title='标题' />
                    <Form>
                        <FormCell>
                            <CellBody>
                                <WKTextarea
                                    value={this.state.title} 
                                    placeholder="课程标题长度1-100字符"
                                    rows="3" 
                                    showCounter={true}
                                    onChange={e => this.bindValue(e, 'title')}
                                    maxLength={100}
                                >
                                </WKTextarea>
                            </CellBody>
                        </FormCell>
                    </Form>
                    <WKGreenTitle title='开课时间' />
                    <Form>
                        <FormCell>
                            <CellBody>
                                <Input 
                                    onFocus={e => this.onFocusTime()}
                                    onChange={e => this.onChangeStartTime(e)} 
                                    type="datetime-local" 
                                    value={this.state.startTime ? TimeStream(this.state.startTime).replace(' ', 'T') : ''} 
                                />
                            </CellBody>
                        </FormCell>
                    </Form>
                    {/* <CellsTitle>加密与付费</CellsTitle> */}
                    <WKGreenTitle title='加密与付费' />
                    <Form className={this.state.isChannelNeedMoney ? '' : 'margin-bottom'} radio className="noMargin">
                        <FormCell radio>
                            <CellBody>{this.state.isChannelNeedMoney ? '试听课' : '免费课'}</CellBody>
                            <CellFooter>
                                <Radio 
                                    name="pay" 
                                    checked={this.state.selectedRadio === 'free'} 
                                    onChange={e => this.onChangeRadio(e, 'free')} 
                                />
                            </CellFooter>
                        </FormCell>
                        <FormCell radio>
                            <CellBody>付费课</CellBody>
                            <CellFooter>
                                <Radio 
                                    name="pay" 
                                    checked={this.state.selectedRadio === 'unfree'} 
                                    onChange={e => this.onChangeRadio(e, 'unfree')} 
                                />
                            </CellFooter>
                        </FormCell>
                        <FormCell radio >
                            <CellBody>加密课</CellBody>
                            <CellFooter>
                                <Radio 
                                    name="pay" 
                                    checked={this.state.selectedRadio === 'password'} 
                                    onChange={e => this.onChangeRadio(e, 'password')} 
                                />
                            </CellFooter>
                        </FormCell>
                        {
                            this.state.isChannelNeedMoney && <FormCell radio>
                                <CellBody>必须购买专栏</CellBody>
                                <CellFooter>
                                    <Radio 
                                        name="pay" 
                                        checked={this.state.selectedRadio === 'payChannel'} 
                                        onChange={e => this.onChangeRadio(e, 'payChannel')} 
                                    />
                                </CellFooter>
                            </FormCell>
                        }
                    </Form>
                    <WKVisible create={this.state.isChannelNeedMoney}>
                        <p className="intro">"必须购买专栏"的直播课程没有单课价格，用户购买专栏前不能访问单课介绍页，可以不编辑单课介绍，专注优化专栏介绍页</p>
                    </WKVisible>
                    {/* 下面是按需显示的组件 */}
                    <WKVisible className='margin-bottom' show={this.state.selectedRadio === 'password'}>
                        <Form>
                            <FormCell>
                                <CellHeader>
                                    <Label>密码</Label>
                                </CellHeader>
                                <CellBody>
                                    <Input 
                                        onChange={e => this.bindValue(e, 'password')} 
                                        type="number"
                                        pattern="[0-9]*"
                                        placeholder="请输入密码"
                                        value={this.state.password}
                                        className='text-right'
                                    />
                                </CellBody>
                            </FormCell>
                        </Form>
                        <p className="intro">仅限数字</p>
                    </WKVisible>
                    <WKVisible show={this.state.selectedRadio === 'unfree'}>
                        <Form>
                            <FormCell>
                                <CellHeader>
                                    <Label>价格（元）</Label>
                                </CellHeader>
                                <CellBody>
                                    <Input 
                                        onChange={e => this.bindValue(e, 'money')} 
                                        type="number"
                                        placeholder="请输入价格"
                                        value={this.state.money}
                                        className='text-right'
                                    />
                                </CellBody>
                            </FormCell>
                            <FormCell switch>
                                <CellBody>设置邀请奖励</CellBody>
                                <CellFooter>
                                    <Switch 
                                        checked={this.state.isResell} 
                                        onChange={e => this.setState({ isResell: e.target.checked })} 
                                    />
                                </CellFooter>
                            </FormCell>
                            <WKVisible create={this.state.isResell} tag={null}>
                                <FormCell>
                                    <CellHeader>
                                        <Label className='long-label'>分成比例（%）</Label>
                                    </CellHeader>
                                    <CellBody>
                                        <Input 
                                            className='text-right'
                                            value={this.state.resellPercent}
                                            onChange={e => this.bindValue(e, 'resellPercent')} 
                                            type="number" 
                                            pattern='[0-9]*'
                                            placeholder="请输入分成比例"
                                            disabled={!this.state.isResell}
                                        />
                                    </CellBody>
                                </FormCell>
                            </WKVisible>
                        </Form>
                    </WKVisible>

                    <WKVisible show={this.state.selectedRadio === 'unfree'}>
                        <p className="intro">邀请奖励可以刺激用户分享给好友</p>
                    </WKVisible>

                    <div className="wk-btn-90" style={{marginTop:'10px'}}>
                        <Button onClick={() => this.onSubmit()}>完成创建</Button>
                    </div>
                    {
                        this.state.showExample && (
                            <div className="example-dialog" onClick={() => this.setState({showExample:false})}>
                                <img src={this.state.showExamplePic} onClick={(e) => e.stopPropagation()} alt='示例' />
                                <img 
                                    src="https://static-1253442168.image.myqcloud.com/picture/6163344_7c67e5ae21bb976b6f1efbc91bf388c2.jpg" 
                                    className="close-btn" alt='关闭'
                                    onClick={() => this.setState({showExample:false})}
                                />
                            </div> 
                        )
                    }
                </div>
                
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Dialog type="ios" title='' buttons={[
                    { label: '确定', onClick: () => this.onClickSuccessOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
            </Page>
        )
    }
}

export default LectureCreateFormPage



// WEBPACK FOOTER //
// ./src/pages/lectureCreate/LectureCreateFormPage.js